import {SITE_DOMAIN} from '@utils';
import {useRegisterSeoTitle} from './Seo';

export const SiteTitle = ({title}: {title: string}) => {
    useRegisterSeoTitle(`${title} | ${SITE_DOMAIN}`);

    return null;
};
